import { render } from "./NewTDATariffsSubscription.vue?vue&type=template&id=4ec9becd&scoped=true"
import script from "./NewTDATariffsSubscription.vue?vue&type=script&lang=js"
export * from "./NewTDATariffsSubscription.vue?vue&type=script&lang=js"

import "./NewTDATariffsSubscription.vue?vue&type=style&index=0&id=4ec9becd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec9becd"]])

export default __exports__